import React from "react"
import { Link, FaIcon } from "lib"
import LanguageSelector from "./LanguageSelector"
import MobileMenuButton from "../menu/MobileMenuButton"
import MainMenu from "../menu/MainMenu"
import Logo from "./Logo"

const Header = ({ node, language, first, menu, location }) => (
    <header role="banner" id="header" key="header">
        <div inner="">
            <Link id="logo" to={`/${language}.html`}>
                <Logo type="header" />
            </Link>
            <div className="header-in">
                <MainMenu menu={menu} language={language} />

                <div id="social-links">
                  <a className="social-link twitter" href="https://x.com/wintercom_" target="_blank">
                    <FaIcon icon="faTwitter" />
                  </a>
                  <a className="social-link linkedin" href="https://ro.linkedin.com/in/cosmin-pop-23160772" target="_blank">
                    <FaIcon icon="faLinkedin" />
                  </a>
                </div>

                <LanguageSelector node={node} language={language} />
                <MobileMenuButton />
            </div>
        </div>
    </header>
)

export default Header
